import type React from "react"

/**
 * Props for a control that is unavailable but must still explain itself.
 *
 * `disabled` takes a control out of the tab order, so the tooltip saying why
 * it is unavailable can never be reached from the keyboard.
 */
export const unavailableProps = (
  unavailable: boolean,
  onClick?: React.MouseEventHandler<HTMLElement>
) => ({
  "aria-disabled": unavailable || undefined,
  // antd's own disabled class, so the look follows the button's variant.
  className: unavailable ? "ant-btn-disabled" : undefined,
  // Swallowed, not dropped: the row underneath must not act on the refused click.
  onClick: unavailable
    ? (event: React.MouseEvent<HTMLElement>) => event.stopPropagation()
    : onClick
})
